import { Button } from '@/components/button';
import { HSeparator } from '@/components/separator';
import { Tag } from '@/components/tag';
import { FormatCurrency } from '@/routes/root';
import { CheckIcon } from '@heroicons/react/24/outline';
import { ExclamationCircleIcon, TicketIcon } from '@heroicons/react/24/solid';
import moment from 'moment';
import React from 'react';

export interface TicketCardProps {
  ticket: any;
  mode?: 'private' | 'public';
  isCurrentTicket?: boolean;
  onTicketClicked?: (id: string) => void;
}

export const TicketCard: React.FC<TicketCardProps> = ({
  ticket,
  mode = 'public',
}) => {
  const isPrivate = mode === 'private';

  return (
    <div className='w-full overflow-hidden rounded border border-gray-300'>
      <div className='flex h-[80px] items-center justify-between bg-purple-700 px-4 py-2 text-white'>
        <div className='flex items-center'>
          <div className='mr-2 rounded-full bg-white p-2 text-purple-700'>
            <TicketIcon className='h-[20px] w-[20px] text-purple-500' />
          </div>
          <span className='font-semibold'>{ticket.name}</span>
        </div>
        <div>
          <div>
            <span className='font-bold text-white'>
              <FormatCurrency amount={ticket.price} />
            </span>
          </div>
          {ticket.is_sold && (
            <div className={'flex justify-end'}>
              <Tag color='danger'>SOLD</Tag>
            </div>
          )}
        </div>
      </div>
      <div className='bg-white px-4 py-4'>
        <p className={'list-disc whitespace-pre-wrap pl-4 text-gray-600'}>
          {ticket.description ?? 'Tidak ada keterangan'}
        </p>
      </div>
      <div>
        <HSeparator />
        <div className='bg-white px-4 py-3'>
          {ticket.is_waiting_open && TicketWillOpen(ticket)}
          {ticket.is_open && TicketAlreadyOpen(isPrivate)}
          {(ticket.is_sold || ticket.is_sell_date_end) && TicketAlreadyClosed()}
        </div>
      </div>
    </div>
  );
};

const TicketWillOpen = (ticket: any) => {
  return (
    <div className={'flex justify-between'}>
      <div className={'flex gap-1'}>
        <ExclamationCircleIcon className='my-auto h-[20px] w-[20px] text-red-500' />
        <span className='font-semibold'>Tiket akan segera dijual</span>
      </div>
      <div>
        <span className='font-semibold text-red-600'>
          {moment(ticket.start_sell_at).fromNow()}
        </span>
      </div>
    </div>
  );
};

const TicketAlreadyClosed = () => {
  return (
    <div className={'flex justify-between'}>
      <div className={'flex gap-1'}>
        <ExclamationCircleIcon className='my-auto h-[20px] w-[20px] text-red-500' />
        <span className='font-semibold'>Tiket sudah selesai/habis terjual</span>
      </div>
    </div>
  );
};

const TicketAlreadyOpen = (isPrivate: boolean) => {
  return (
    <div className={'flex justify-between'}>
      <div className={'my-auto flex gap-1'}>
        <CheckIcon className='my-auto h-[20px] w-[20px] text-green-500' />
        <span className='font-semibold'>Tiket masih bisa dibeli</span>
      </div>
      {isPrivate && (
        <div>
          <Button look={'outline'} variant={'neutral'}>
            Pilih
          </Button>
        </div>
      )}
    </div>
  );
};
